export enum AnalyticsEvent {
  CHAT_MESSAGE_SENT = 'chat_message_sent',
  CHAT_MESSAGE_ERROR = 'chat_message_error',
  RETURN_TO_SEARCH = 'return_to_search',
  CATEGORY_ROUTE_SEARCH = 'category_route_search',
  SUPERBAR_DISPLAYED = 'superbar_displayed',
  CHAT_MESSAGE_PROCESSING = 'chat_message_processing',
  PRODUCTS_GALLERY_VIEWED = 'products_gallery_viewed',
  ANSWER_RESPONSE_SHOWN = 'answer_response_shown',
  PRODUCT_DETAILS_VIEWED = 'product_details_viewed',
  NO_SEARCH_RESULTS_FOUND = 'no_search_results_found',
  AI_FILTER_SELECTED = 'ai_filter_selected',
  AI_FILTERS_SHOWN = 'ai_filters_shown',
  POWERED_BY_SUPERBAR_CLICK = 'powered_by_superbar_click',
  SUPERBAR_API_EXPAND = 'superbar_api_expand',
  SUPERBAR_API_MINIMIZE = 'superbar_api_minimize',
  SUPERBAR_API_CLOSE = 'superbar_api_close',
  SUPERBAR_API_SEND_MESSAGE = 'superbar_api_send_message',
  SUPERBAR_API_CLEAR_MESSAGE = 'superbar_api_clear_message',
  SUPERBAR_API_ONBOARDING_MESSAGE_STARTED = 'superbar_api_onboarding_message_started',
  SUPERBAR_API_ONBOARDING_MESSAGE_SUCCESS = 'superbar_api_onboarding_message_success',
  SUPERBAR_API_ONBOARDING_MESSAGE_ERROR = 'superbar_api_onboarding_message_error',
  FEEDBACK_THUMBS_UP_CLICKED = 'feedback_thumbs_up_clicked',
  FEEDBACK_IMPROVE_ANSWER_CLICKED = 'feedback_improve_answer_clicked',
  FEEDBACK_IMPROVE_ANSWER_SUBMITTED = 'feedback_improve_answer_submitted',
  SUPERBAR_HOVER = 'superbar_hover',
  SUPERBAR_LONG_HOVER = 'superbar_long_hover',
  SUPERBAR_EXIT_INTENT_SHOWN = 'superbar_exit_intent_shown',
  SUPERBAR_AUTO_EXPAND_TRIGGERED = 'superbar_auto_expand_triggered',
  SUPERBAR_FOOTER_EXPAND_TRIGGERED = 'superbar_footer_expand_triggered',
  CONVERSION_PAGE_DISPLAYED = 'conversion_page_displayed',
  PURCHASE_DETECTED = 'purchase_detected',
  SUPERBAR_API_TRACK_PURCHASE = 'superbar_api_track_purchase',
  TTS_PLAY_REQUESTED = 'tts_play_requested',
  TTS_PLAY_STARTED = 'tts_play_started',
  TTS_PLAY_COMPLETED = 'tts_play_completed',
  TTS_PLAY_STOPPED = 'tts_play_stopped',
  TTS_PLAY_ERROR = 'tts_play_error',
  VOICE_INPUT_STARTED = 'voice_input_started',
  VOICE_INPUT_COMPLETED = 'voice_input_completed',
  VOICE_INPUT_ERROR = 'voice_input_error',
  VOICE_MODE_STARTED = 'voice_mode_started',
  VOICE_MODE_ENDED = 'voice_mode_ended',
  VOICE_MODE_TURN_COMPLETED = 'voice_mode_turn_completed',
  VOICE_MODE_TTS_FALLBACK = 'voice_mode_tts_fallback',
  TTS_MUTE_ENABLED = 'tts_mute_enabled',
  TTS_MUTE_DISABLED = 'tts_mute_disabled',
  TTS_PLAY_MUTED_SKIP = 'tts_play_muted_skip',
  VOICE_MODE_MAX_TURNS_REACHED = 'voice_mode_max_turns_reached',
  PAGE_CRAWLED = 'page_crawled',
}
